import { render, staticRenderFns } from "./BonusComplianceList.vue?vue&type=template&id=a6b87444"
import script from "./BonusComplianceList.vue?vue&type=script&lang=js"
export * from "./BonusComplianceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports